module.exports = __webpack_public_path__ + "static/media/Lato-Regular.bd03a2cc.woff2";